<div class="container-fluid spacer-top-navigation">
  <div class="container kryptoonboarding">
    <div class="tile" [zeroLoadingIndicator]="cryptoOnboardingFacade.loading$ | async">
      <h2>Krypto-Wallet eröffnen</h2>
      @if (cryptoOnboardingFacade.status$ | async; as status) {
        @if (status?.onboardingProgress !== 'ONBOARDED' && status?.onboardingProgress !== 'IN_PROGRESS') {
          <div class="row mt-4">
            <div class="col">
              <p>
                Bevor Du eine kostenlose Wallet eröffnest, solltest Du die angebotenen Dienstleistungen und die damit verbundenen Risiken
                verstehen. Hierzu dienen die nachfolgenden Informationen, die Dir auch per E-Mail an
                <span class="font-bold text-nowrap">{{ (customerStateFacade.accountData$ | async)?.email }}</span> zugesandt werden.
              </p>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-12">
                  <h3>Dokumente Tangany</h3>
                  <p class="mt-3">
                    Unser Partner für die Verwahrung der Krypto-Assets (Kryptowährungen) und Anbieter der Wallet ist die Tangany GmbH.
                  </p>
                  <ul class="list-doc mt-2">
                    <li>
                      <a
                        href="/assets/pdfs/20250218/krypto/tangany/Tangany_AGB.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="link-secondary text-default"
                        >AGBs der Tangany GmbH</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="col-12 mt-4">
                  <h3>Dokumente Baader Bank AG</h3>
                  <p class="mt-3">
                    Der Handel mit Kryptowährungen unterliegt einem hohen Risiko bis hin zum Totalverlust. Kryptowährungen zeichnen sich
                    außerdem durch eine hohe Volatilität aus. Bitte lies die vollständigen Risikohinweise der Baader Bank zum Handel mit
                    Kryptowährungen.
                  </p>
                  <ul class="list-doc mt-2">
                    <li>
                      <a
                        href="/assets/pdfs/20250313/krypto/baader/Vertragsbestandteile_Baader_Bank.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="link-secondary text-default"
                        >Vertragsbestandteile und Risikohinweise der Baader Bank AG</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 mt-4 mt-lg-0">
              <h3>Dokumente finanzen.net zero</h3>
              <p class="mt-3">
                Für den Handel mit Kryptowährungen ist ein gesonderter Rahmenvertrag zur Annahme und Übermittlung von Aufträgen über
                Kryptowerte erforderlich. Des weiteren ist auch ein gesondertes Preis- und Leistungsverzeichnis für Kryptowerte zu beachten.
              </p>
              <ul class="list-doc mt-2">
                <li>
                  <a
                    href="/assets/pdfs/20250218/krypto/zero/zero_Kundendokumente_Preis-Leistungsverzeichnis_Krypto_V1K.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="link-secondary text-default"
                    >Kundendokumente und Preis- / Leistungsverzeichnis</a
                  >
                </li>
              </ul>
            </div>
          </div>
          @if (status && !status.identDocValid) {
            <div class="row mt-4 alert alert-danger m-2 pt-4">
              <div class="col">
                <h3 class="mb-2">Ausweis abgelaufen</h3>
                <p class="mt-3">
                  Dein Ausweisdokument, das Du für die Kontoeröffnung verwendet hast, ist inzwischen abgelaufen. Um die Wallet für Dich
                  eröffnen zu können, musst Du Dein Ausweisdokument zunächst unter
                  <a [routerLink]="commonRoutes.postlogin.verwaltung" class="link-secondary text-default">Verwaltung</a>
                  (Meine Daten) aktualisieren. <br />
                  Anschließend kannst Du mit der Wallet-Eröffnung fortfahren.
                </p>
              </div>
            </div>
          }
          @if (cryptoOnboardingFacade.error$ | async; as ex) {
            @if (ex?.error?.message; as msg) {
              <div class="row mt-4 alert alert-danger m-2">
                <div class="col">{{ msg }}</div>
              </div>
            }
          }
          <div class="row mt-4">
            <div class="col text-center">
              <web-design-system-button
                data-zid="open-wallet"
                size="large"
                (click)="cryptoOnboardingFacade.acceptConditions()"
                [disabled]="
                  !status ||
                  !status.identDocValid ||
                  (cryptoOnboardingFacade.loading$ | async) ||
                  status?.onboardingProgress === 'ONBOARDED' ||
                  status?.onboardingProgress === 'IN_PROGRESS'
                "
              >
                Akzeptieren und weiter
              </web-design-system-button>
            </div>
          </div>
          <div class="flex-column m-3 row">
            <web-components-user-messages />
          </div>
        }
        @if (status?.onboardingProgress === 'ONBOARDED') {
          <div class="row mt-4">
            <div class="col">
              <p>Du hast bereits eine Wallet.</p>
            </div>
          </div>
        }
        @if (status?.onboardingProgress === 'IN_PROGRESS') {
          <div class="row mt-4">
            <div class="col">
              <p>Die Eröffnung Deiner Wallet ist in Bearbeitung.</p>
              <p>Wir benachrichtigen Dich, sobald Deine Wallet eröffnet ist.</p>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
